import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  Alert,
  Col,
  message,
  PageHeader,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tabs,
  Tag,
} from "antd";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import {
  ButtonItem,
  ErrorItem,
  Form,
  FormItem,
  RangePickerItem,
  SelectItem,
  dineroDisabledMask,
} from "../../../../Components/Items";
import { descargarExcel, descargarPdf } from "./exportarFacturasGlobales";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

const PAGINACION = ["25", "50", "100", "200"];

const dinero = (valor) => dineroDisabledMask(valor || 0);
const fmtFecha = (valor) => (valor ? moment(valor).format("DD/MM/YYYY") : "");

const vistaVacia = () => ({
  data: [],
  totalRecords: 0,
  page: 1,
  pageSize: 50,
  sortField: null,
  sortOrder: null,
  totales: {},
  truncado: false,
});

class ReporteFacturasGlobales extends Component {
  formRef = React.createRef();

  state = {
    // Contador, no bandera: las dos vistas se consultan a la vez y con un
    // booleano la que termina primero apaga el spinner de la otra.
    peticiones: 0,
    exportando: false,
    vista: "emitidas",
    emitidas: vistaVacia(),
    pendientes: vistaVacia(),
    // Detalle de remisiones por factura global; se pide al expandir el renglon,
    // no con el listado.
    detalles: {},
    cargandoDetalle: {},
    filtros: {
      periodo: [moment().startOf("month"), moment().endOf("month")],
      estado: "todas",
    },
  };

  componentDidMount() {
    // Las dos vistas de un jalon: son dos consultas paginadas y baratas, y asi
    // las tarjetas de arriba pueden mostrar emitidas y pendientes a la vez.
    this.consultar("emitidas", { page: 1 });
    this.consultar("pendientes", { page: 1 });
  }

  atras() {
    this.props.history.goBack();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  aplicarFiltros(values) {
    this.setState({ filtros: { ...this.state.filtros, ...values }, detalles: {} }, () => {
      this.consultar("emitidas", { page: 1 });
      this.consultar("pendientes", { page: 1 });
    });
  }

  cuerpoConsulta(vista, extra = {}) {
    const { filtros } = this.state;
    const estadoVista = this.state[vista];
    return {
      empresaId: this.props.empresaId,
      periodo: filtros.periodo,
      vista,
      estado: filtros.estado,
      page: estadoVista.page,
      pageSize: estadoVista.pageSize,
      sortField: estadoVista.sortField,
      sortOrder: estadoVista.sortOrder,
      ...extra,
    };
  }

  consultar(vista, { page, pageSize, sortField, sortOrder } = {}) {
    const anterior = this.state[vista];
    const nuevoEstado = {
      ...anterior,
      page: page || anterior.page,
      pageSize: pageSize || anterior.pageSize,
      sortField: sortField !== undefined ? sortField : anterior.sortField,
      sortOrder: sortOrder !== undefined ? sortOrder : anterior.sortOrder,
    };

    const terminar = () =>
      this.setState((estado) => ({ peticiones: Math.max(estado.peticiones - 1, 0) }));

    this.setState(
      (estado) => ({ peticiones: estado.peticiones + 1, [vista]: nuevoEstado }),
      () => {
        axios
          .post(
            "reportesFiscales/reporteFacturasGlobales",
            this.cuerpoConsulta(vista),
            { headers: this.props.headersToken }
          )
          .then((res) => {
            terminar();
            if (res.data.success === 2) {
              this.setState({
                [vista]: {
                  ...this.state[vista],
                  data: res.data.data || [],
                  totalRecords: res.data.totalRecords || 0,
                  totales: res.data.totales || {},
                  truncado: !!res.data.truncado,
                },
              });
            } else {
              message.error(res.data.message || "No se pudo cargar el reporte");
            }
          })
          .catch(() => {
            terminar();
            message.error("Error de conexion");
          });
      }
    );
  }

  /** El detalle de una factura global, la primera vez que se expande su renglon. */
  cargarDetalle(facturaGlobalId) {
    const id = facturaGlobalId.toString();
    if (this.state.detalles[id] || this.state.cargandoDetalle[id]) return;

    this.setState({ cargandoDetalle: { ...this.state.cargandoDetalle, [id]: true } });
    axios
      .post(
        "reportesFiscales/detalleFacturaGlobal",
        { empresaId: this.props.empresaId, facturaGlobalId: id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const cargando = { ...this.state.cargandoDetalle };
        delete cargando[id];
        if (res.data.success === 2) {
          this.setState({
            cargandoDetalle: cargando,
            detalles: { ...this.state.detalles, [id]: { ventas: res.data.ventas || [] } },
          });
        } else {
          this.setState({ cargandoDetalle: cargando });
          message.error(res.data.message || "No se pudo cargar el detalle");
        }
      })
      .catch(() => {
        const cargando = { ...this.state.cargandoDetalle };
        delete cargando[id];
        this.setState({ cargandoDetalle: cargando });
        message.error("Error de conexion");
      });
  }

  descripcionFiltros() {
    const { filtros } = this.state;
    const partes = [];
    if (filtros.periodo && filtros.periodo[0]) {
      partes.push(
        `Del ${moment(filtros.periodo[0]).format("DD/MM/YYYY")} al ${moment(filtros.periodo[1]).format("DD/MM/YYYY")}`
      );
    }
    if (filtros.estado && filtros.estado !== "todas") {
      partes.push(filtros.estado === "vigentes" ? "Solo vigentes" : "Solo canceladas");
    }
    return partes.join(" | ");
  }

  /** Excel y PDF traen el periodo completo de las DOS vistas, no la pagina. */
  exportar(formato) {
    this.setState({ exportando: true });
    Promise.all([
      axios.post(
        "reportesFiscales/reporteFacturasGlobales",
        this.cuerpoConsulta("emitidas", { exportar: true }),
        { headers: this.props.headersToken }
      ),
      axios.post(
        "reportesFiscales/reporteFacturasGlobales",
        this.cuerpoConsulta("pendientes", { exportar: true }),
        { headers: this.props.headersToken }
      ),
    ])
      .then(([resEmitidas, resPendientes]) => {
        this.setState({ exportando: false });
        if (resEmitidas.data.success !== 2 || resPendientes.data.success !== 2) {
          message.error("No se pudo generar el archivo");
          return;
        }
        const emitidas = resEmitidas.data.data || [];
        const pendientes = resPendientes.data.data || [];
        if (emitidas.length === 0 && pendientes.length === 0) {
          message.info("No hay facturas globales ni remisiones pendientes en el periodo");
          return;
        }
        if (resEmitidas.data.truncado || resPendientes.data.truncado) {
          message.warning(
            "El periodo excede el maximo del reporte: el archivo sale truncado. Acorta el rango de fechas."
          );
        }
        const params = {
          emitidas,
          pendientes,
          detalles: this.state.detalles,
          empresaNombre: this.props.empresa,
          descripcionFiltros: this.descripcionFiltros(),
          totalesEmitidas: resEmitidas.data.totales || {},
          totalesPendientes: resPendientes.data.totales || {},
        };
        if (formato === "excel") descargarExcel(params);
        else descargarPdf(params);
      })
      .catch(() => {
        this.setState({ exportando: false });
        message.error("Error de conexion");
      });
  }

  columnasEmitidas() {
    return [
      {
        title: "Folio",
        dataIndex: "serieNumero",
        key: "folio",
        width: 140,
        sorter: true,
        render: (valor, registro) => (
          <div>
            <div style={{ fontWeight: 600 }}>
              {valor || [registro.facturaSerie, registro.facturaNumero].filter(Boolean).join(" - ")}
            </div>
            <div style={{ fontSize: 10, color: "#8c8c8c" }}>
              {(registro.uuid || "").slice(0, 8)}...
            </div>
          </div>
        ),
      },
      {
        title: "Fecha",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        width: 105,
        align: "center",
        sorter: true,
        defaultSortOrder: "descend",
        render: fmtFecha,
      },
      {
        title: "Periodo",
        key: "descripcionPeriodo",
        dataIndex: "descripcionPeriodo",
        width: 230,
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyectoNombre",
        key: "proyectoNombre",
        width: 180,
        ellipsis: true,
      },
      {
        title: "Remisiones",
        dataIndex: "ventas",
        key: "ventas",
        width: 105,
        align: "center",
      },
      {
        title: "Subtotal",
        dataIndex: "subtotal",
        key: "subtotal",
        width: 140,
        align: "right",
        sorter: true,
        render: dinero,
      },
      {
        title: "Impuestos",
        dataIndex: "impuestos",
        key: "impuestos",
        width: 140,
        align: "right",
        render: dinero,
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        width: 140,
        align: "right",
        sorter: true,
        render: (valor) => <b>{dinero(valor)}</b>,
      },
      {
        title: "CFDI",
        dataIndex: "porVenta",
        key: "porVenta",
        width: 120,
        render: (valor) => (
          <Tag color={valor ? "blue" : "default"}>{valor ? "Por venta" : "Por insumo"}</Tag>
        ),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: 110,
        render: (valor) => (
          <Tag color={valor === 0 ? "red" : "green"}>{valor === 0 ? "Cancelada" : "Vigente"}</Tag>
        ),
      },
    ];
  }

  columnasDetalle() {
    return [
      { title: "Remision", dataIndex: "folio", key: "folio", width: 130 },
      {
        title: "Fecha",
        dataIndex: "fechaRemision",
        key: "fechaRemision",
        width: 110,
        align: "center",
        render: fmtFecha,
      },
      { title: "Cliente", dataIndex: "nombreCliente", key: "nombreCliente", width: 250, ellipsis: true },
      { title: "RFC", dataIndex: "rfcCliente", key: "rfcCliente", width: 140 },
      { title: "Subtotal", dataIndex: "subtotal", key: "subtotal", width: 130, align: "right", render: dinero },
      { title: "Impuestos", dataIndex: "impuestos", key: "impuestos", width: 130, align: "right", render: dinero },
      { title: "Total", dataIndex: "total", key: "total", width: 130, align: "right", render: dinero },
      {
        title: "Estado",
        key: "estadoRemision",
        width: 180,
        render: (_, registro) => {
          // Una remision que se saco de la global para facturarse aparte queda
          // marcada con `facturaDeGlobal` y ya no forma parte del CFDI vigente.
          if (registro.facturaDeGlobal) return <Tag color="orange">Extraida de la global</Tag>;
          if (registro.estado === 0) return <Tag color="red">Cancelada</Tag>;
          return <Tag color="green">Vigente</Tag>;
        },
      },
    ];
  }

  columnasPendientes() {
    return [
      {
        title: "Remision",
        dataIndex: "serieNumero",
        key: "folio",
        width: 140,
        sorter: true,
        render: (valor, registro) =>
          valor || [registro.remisionSerie, registro.remisionNumero].filter(Boolean).join(" - "),
      },
      {
        title: "Fecha",
        dataIndex: "fechaRemision",
        key: "fechaRemision",
        width: 105,
        align: "center",
        sorter: true,
        defaultSortOrder: "descend",
        render: fmtFecha,
      },
      {
        title: "Cliente",
        dataIndex: "nombreCliente",
        key: "cliente",
        width: 250,
        ellipsis: true,
        sorter: true,
        render: (valor, registro) => (
          <div>
            <div>{valor}</div>
            <div style={{ fontSize: 11, color: "#8c8c8c" }}>{registro.rfcCliente}</div>
          </div>
        ),
      },
      { title: "Proyecto", dataIndex: "proyectoNombre", key: "proyectoNombre", width: 180, ellipsis: true },
      { title: "Forma de pago", dataIndex: "formaDePago", key: "formaDePago", width: 200, ellipsis: true },
      { title: "Subtotal", dataIndex: "subtotal", key: "subtotal", width: 140, align: "right", render: dinero },
      { title: "Impuestos", dataIndex: "impuestos", key: "impuestos", width: 140, align: "right", render: dinero },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        width: 140,
        align: "right",
        sorter: true,
        render: (valor) => <b>{dinero(valor)}</b>,
      },
      { title: "Cobrado", dataIndex: "totalPagado", key: "totalPagado", width: 140, align: "right", render: dinero },
    ];
  }

  tarjetasResumen() {
    const emitidas = this.state.emitidas.totales || {};
    const pendientes = this.state.pendientes.totales || {};

    const tarjetas = [
      { etiqueta: "Globales emitidas", valor: String(emitidas.documentos || 0) },
      { etiqueta: "Canceladas", valor: String(emitidas.canceladas || 0), color: "#a8071a" },
      { etiqueta: "Remisiones globalizadas", valor: String(emitidas.ventas || 0) },
      { etiqueta: "Subtotal facturado", valor: dinero(emitidas.subtotal) },
      { etiqueta: "Total facturado", valor: dinero(emitidas.total) },
      { etiqueta: "Pendientes de globalizar", valor: String(pendientes.documentos || 0), color: "#d46b08" },
      { etiqueta: "Importe pendiente", valor: dinero(pendientes.total), color: "#d46b08" },
    ];

    return (
      <Row gutter={[8, 8]} style={{ marginBottom: 10 }}>
        {tarjetas.map((tarjeta) => (
          <Col key={tarjeta.etiqueta} xs={12} sm={8} md={6} lg={3}>
            <div
              style={{
                backgroundColor: "white",
                borderRadius: 5,
                padding: "10px 12px",
                borderTop: `3px solid ${tarjeta.color || "#00BFD6"}`,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                height: "100%",
              }}
            >
              <div style={{ fontSize: 11, color: "#8c8c8c" }}>{tarjeta.etiqueta}</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: tarjeta.color || "#005F6B" }}>
                {tarjeta.valor}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    );
  }

  tablaDe(vista, columnas, extra = {}) {
    const estadoVista = this.state[vista];
    return (
      <Table
        size="small"
        rowKey={(registro) => registro._id.toString()}
        columns={columnas}
        dataSource={estadoVista.data}
        loading={this.state.peticiones > 0}
        scroll={{ x: "max-content" }}
        pagination={{
          current: estadoVista.page,
          pageSize: estadoVista.pageSize,
          total: estadoVista.totalRecords,
          showSizeChanger: true,
          pageSizeOptions: PAGINACION,
          showTotal: (total) => `${total} registro(s)`,
        }}
        onChange={(paginacion, filtrosTabla, orden) =>
          this.consultar(vista, {
            page: paginacion.current,
            pageSize: paginacion.pageSize,
            sortField: orden && orden.order ? orden.columnKey : null,
            sortOrder: (orden && orden.order) || null,
          })
        }
        {...extra}
      />
    );
  }

  render() {
    const { exportando } = this.state;
    const loading = this.state.peticiones > 0;
    const hayDatos = this.state.emitidas.data.length > 0 || this.state.pendientes.data.length > 0;

    return (
      <Form
        ref={this.formRef}
        name="reporteFacturasGlobales"
        onFinish={this.aplicarFiltros.bind(this)}
        onFinishFailed={this.onFinishFailed}
        initialValues={this.state.filtros}
      >
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Facturas Globales"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              {hayDatos && (
                <ButtonItem
                  blanco
                  icon={<FileExcelOutlined />}
                  loading={exportando}
                  onClick={() => this.exportar("excel")}
                >
                  Excel
                </ButtonItem>
              )}
              {hayDatos && (
                <ButtonItem
                  blanco
                  icon={<FilePdfOutlined />}
                  loading={exportando}
                  onClick={() => this.exportar("pdf")}
                >
                  PDF
                </ButtonItem>
              )}
              <ButtonItem type="primary" htmlType="submit">
                Consultar
              </ButtonItem>
            </Space>
          }
        />

        <Spin spinning={loading}>
          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingTop: 5,
              borderRadius: 5,
              marginBottom: 10,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Tabs
              style={{ margin: 0 }}
              tabBarExtraContent={{
                left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
              }}
            >
              <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                <Row gutter={16}>
                  <Col span={10}>
                    <FormItem name="periodo" required noStyle margin>
                      <RangePickerItem />
                    </FormItem>
                    <div style={{ fontSize: 11, color: "#8c8c8c" }}>
                      Aplica a la fecha de la factura global y a la fecha de remision
                      de las pendientes.
                    </div>
                  </Col>
                  <Col span={6}>
                    <FormItem name="estado" noStyle margin>
                      <SelectItem width="95%" placeholder="Estado">
                        <Option value="todas">Todas</Option>
                        <Option value="vigentes">Solo vigentes</Option>
                        <Option value="canceladas">Solo canceladas</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </div>

          {this.tarjetasResumen()}

          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingTop: 5,
              borderRadius: 5,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Tabs
              activeKey={this.state.vista}
              onChange={(vista) => this.setState({ vista })}
            >
              <TabPane
                key="emitidas"
                tab={`Emitidas (${this.state.emitidas.totalRecords})`}
              >
                <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 8 }}>
                  Expande un renglon para ver las remisiones que agrupa. El detalle se
                  carga solo al expandirlo, y el Excel incluye una hoja con el de las
                  facturas que hayas abierto.
                </div>
                {this.tablaDe("emitidas", this.columnasEmitidas(), {
                  expandable: {
                    onExpand: (expandido, registro) => {
                      if (expandido) this.cargarDetalle(registro._id);
                    },
                    rowExpandable: (registro) => registro.ventas > 0,
                    expandedRowRender: (registro) => {
                      const id = registro._id.toString();
                      const detalle = this.state.detalles[id];
                      return (
                        <Spin spinning={!!this.state.cargandoDetalle[id]}>
                          <Table
                            size="small"
                            rowKey={(venta) => venta._id.toString()}
                            columns={this.columnasDetalle()}
                            dataSource={(detalle && detalle.ventas) || []}
                            pagination={false}
                            scroll={{ x: "max-content", y: 320 }}
                          />
                        </Spin>
                      );
                    },
                  },
                })}
              </TabPane>

              <TabPane
                key="pendientes"
                tab={`Pendientes de globalizar (${this.state.pendientes.totalRecords})`}
              >
                <Alert
                  style={{ marginBottom: 10 }}
                  type="info"
                  showIcon
                  message="Remisiones que cumplen la regla de la factura global y siguen sin facturarse"
                  description="Son las mismas que ofrece la pantalla de generar factura global: remision emitida, sin factura propia, vigente, en pesos, sin retenciones y que no sea consignacion ni anticipo."
                />
                {this.tablaDe("pendientes", this.columnasPendientes())}
              </TabPane>
            </Tabs>
          </div>
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresa: state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteFacturasGlobales);
